import Icon from '@/components/snippets/icon/icon'
import { useEffect, useRef } from 'preact/hooks'

export function FilterCollapse({ label, children, activeFilterLabel }) {
  const id = `filter-${label.toLowerCase().replace(/\s/g, '-')}`
  const displayLabel = activeFilterLabel ? `${label} (${activeFilterLabel})` : label
  const modalRef = useRef(null)
  const isSortAccordion = id === 'filter-sort-by'

  useEffect(() => {
    const modal = modalRef.current
    if (!modal) return

    if (isSortAccordion) {
      const handleOpen = () => {
        if (modal.dataset.ui !== 'visible') {
          modal.handleToggle?.()
        }
      }
      const handleClose = () => {
        if (modal.dataset.ui === 'visible') {
          modal.handleToggle?.()
        }
      }

      window.addEventListener('searchspring:open-sort-accordion', handleOpen)
      window.addEventListener('searchspring:close-sort-accordion', handleClose)
      return () => {
        window.removeEventListener('searchspring:open-sort-accordion', handleOpen)
        window.removeEventListener('searchspring:close-sort-accordion', handleClose)
      }
    } else {
      const handleClose = () => {
        if (modal.dataset.ui === 'visible') {
          modal.handleToggle?.()
        }
      }

      window.addEventListener('searchspring:close-filter-accordions', handleClose)
      return () => window.removeEventListener('searchspring:close-filter-accordions', handleClose)
    }
  }, [isSortAccordion])

  return (
    <x-modal ref={modalRef} data-id={id} className="group/filter dropdown-modal flex flex-col border-b border-brand-medium" data-toggle-group="true">
      <button
        className="flex items-center justify-between gap-x-0.75 min-h-[56px] px-1 md:px-1.5 py-1 text-left link-fade"
        data-modal-parent={id}
        data-modal-role="toggle"
        aria-label={label}
      >
        <span className="paragraph-m font-semibold">{displayLabel}</span>
        <div className={'flex w-[12px] h-[7px] group-data-visible/filter:-rotate-180 transition-all children:size-full'}>
          <Icon id="chevron-down" />
        </div>
      </button>
      <div className="dropdown-content">
        <div className="flex flex-col gap-1.5 overflow-hidden">{children}</div>
      </div>
    </x-modal>
  )
}
